import axios from 'axios';

// redirect to logout when request is unauthorized
axios.interceptors.response.use(response => response, function (error) {
  if (error && error.response && error.response.status === 401) {
    window.open('/logout', '_self');
  } else {
    return Promise.reject(error);
  }
});
